import PageSection from '@sayyesschool/frontend/components/page-section';

import RequestsList from '@/components/requests/requests-list';

export default function ManagerRequests({ requests }) {
    return (
        <PageSection
            className="ManagerRequests"
            title="Заявки"
            compact
        >
            {requests?.length > 0 &&
                <RequestsList requests={requests} />
            }
        </PageSection>
    );
}